export default __webpack_public_path__ + "static/media/older_kid_action.a0ea284c.jpg";